import { logger } from '@/lib/logger';

/**
 * Chat Store Helper Functions and WebSocket Error Store
 * 
 * 後方互換性のために維持されている関数群とWebSocketエラー管理
 */

import { proxy } from 'valtio';
import { ChatMessage } from '@/types/chat';

// WebSocketエラー管理用のストア
export const wsErrorStore = proxy({
  hasShownError: false,
  errorMessage: '',
});

// チャット状態のページ別キャッシュ
const pageStateCache = new Map<string, {
  messages: ChatMessage[];
  conversationHistory: Array<{ role: string; content: string }>;
}>();

// ページ別のチャット状態を保存
export function saveChatStateForPage(pageId: string, state: {
  messages: ChatMessage[];
  conversationHistory: Array<{ role: string; content: string }>;
}) {
  pageStateCache.set(pageId, {
    messages: [...state.messages],
    conversationHistory: [...state.conversationHistory],
  });
}

// ページ別のチャット状態を読み込み
export function loadChatStateForPage(pageId: string) {
  return pageStateCache.get(pageId);
}

// 特定ページのキャッシュをクリア
export function clearPageCache(pageId: string) {
  pageStateCache.delete(pageId);
}

// 全てのページキャッシュをクリア
export function clearAllPageCaches() {
  pageStateCache.clear();
}

// チャットストアのクリーンアップ（メモリリーク防止）
export function cleanupChatStore() {
  // キャッシュサイズが大きくなりすぎた場合、古いエントリを削除
  if (pageStateCache.size > 50) {
    const entries = Array.from(pageStateCache.entries());
    // 最初の10個を削除（古いエントリ）
    entries.slice(0, 10).forEach(([pageId]) => {
      pageStateCache.delete(pageId);
    });
  }
  
  // WebSocketエラー状態をリセット
  wsErrorStore.hasShownError = false;
  wsErrorStore.errorMessage = '';
}

// チャット状態のデバッグ用ログ出力
export function logChatState() {
  logger.debug('Chat State Cache:', {
    cacheSize: pageStateCache.size,
    cachedPages: Array.from(pageStateCache.keys()),
    wsErrorState: {
      hasShownError: wsErrorStore.hasShownError,
      errorMessage: wsErrorStore.errorMessage,
    },
  });
}